<template>
  <f7-page class="div-frmPaletizadoMultiPunto">
    <div class="menu">
      <PCSideNavbar
        show-more-button
        @item-clicked="OpcionSideNavbarSeleccionada"
      />
    </div>

    <div class="div-contenido">
      <f7-row>
        <f7-col width="100">
          <f7-row style="height: 15vh;">
            <f7-col
              width="25"
              style="max-width: 250px; margin-top: 18px; border-right: 1px solid rgb(151 151 151 / 30%);"
            >
              <span v-if="logoApp">
                <img
                  id="logo"
                  alt="logoEmpresa"
                  class="logo-empresa-frmTablet"
                  :src="logoApp"
                >
              </span>
              <span v-else>
                <img
                  id="logo"
                  alt="logoHispatec"
                  class="logo-empresa-frmTablet"
                  :src="LOGO_HISPATEC"
                >
              </span>
            </f7-col>
            <f7-col
              width="50"
              class="temp-padding-top"
            >
              <!-- <UCLineasDeProduccion
                :valor-por-defecto="lineaSeleccionadaAlIniciarFormulario"
                plantilla="P2"
                :mostrar-titulo="false"
                :deshabilitar-controles-de-avance-y-retroceso="contadorDeLlamadasPendientesDeRespuestaEnFrm === 0 ? false : true"
                @lineaProduccionSeleccionada="LineaProduccionSeleccionada"
              /> -->
              <UCSearchEntityERP
                :placeholder="$t('common.productionLine')"
                :search-text="$t('searchEntity.line.searchText')"
                :search-cancellation-text="$t('searchEntity.line.searchCancellationText')"
                :search-not-found-text="$t('searchEntity.line.searchNotFoundText')"
                :default-value="lineaSeleccionadaAlIniciarFormulario"
                :default-etities-list="lineasProduccion"
                :property-entity-shown-input="['Codigo', 'Nombre']"
                :property-entity-shown-list-title="['Codigo']"
                :property-entity-shown-list-subtitle="['Nombre']"
                :min-text-search="0"
                :next-and-previous-buttons-shown="true"
                :autofocus-on-deselection="true"
                :disabled="contadorDeLlamadasPendientesDeRespuestaEnFrm === 0 ? false : true"
                :auto-focus-on-empty-search-result="true"
                @selection="LineaProduccionSeleccionada"
              />
            </f7-col>
            <f7-col
              width="25"
              class="div-logoHispatecDerecha"
            >
              <img
                id="logo"
                alt="logoHispatec"
                class="img-logoHispatec"
                :src="LOGO_HISPATEC"
              >
            </f7-col>
          </f7-row>
          <f7-row>
            <f7-col width="60">
              <span class="span-tituloColumnas no-seleccionable">PUNTOS DE PALETIZADO</span>
              <div class="div-puntosPaletizadoDisponibles">
                <!-- Cabecera -->
                <div class="div-botonesCabeceraFijos">
                  <div
                    class="div-cargarModelo seleccionable"
                    @click="AbrirFormularioDeModelosParaPuntosDePaletizado()"
                  >
                    <span class="span-cargarModelo"> Cargar Modelo</span>
                  </div>
                  <div
                    class="div-buscarPale seleccionable"
                    @click="AbrirPopupParaBusquedaDePales()"
                  >
                    <span class="span-cargarModelo"> Buscar Palé </span>
                  </div>
                </div>
                <!-- Contenido Scroll -->
                <div class="div-puntosPaletizadoDisponibles-scroll">
                  <div class="div-elementosPuntosDePaletizado">
                    <UCPreload :show="mostrarPrecarga" />
                    <div
                      v-for="punto in puntosDePaletizado"
                      :key="punto.Id"
                      class="div-elementoTarjeta"
                      :class="{
                        'div-elementoTarjetaSeleccionado': puntoDePaletizadoSeleccionado === punto ? true : false,
                        'div-elementoNoEditable': puntoDePaletizadoSeleccionado !== punto && modoEdicionActivo ? true : false,
                      }"
                      @click="PuntoPaletizadoSeleccionado(punto)"
                    >
                      <!-- Cabecera Tarjetas Asignadas con Pedidos -->
                      <f7-row
                        v-if="ObtenerPedidoAsignadoPuntoDePaletizado(punto) != null"
                        class="row-cabeceraTarjeta"
                      >
                        <f7-col
                          width="60"
                          style="margin-left: 10px;"
                        >
                          <span class="span-texto-azulOscuro-18-500 span-textoCabeceraTarjetaPedido">
                            {{ `${ObtenerPedidoAsignadoPuntoDePaletizado(punto).Pedido} ${ObtenerPedidoAsignadoPuntoDePaletizado(punto).NombreCliente}` }}
                          </span>
                        </f7-col>
                        <f7-col
                          width="40"
                          class="div-cabeceraTarjetaDerecha"
                        >
                          <div
                            v-if="punto.UbicacionDefectoPalesProducidos != null
                              && punto.UbicacionPalesProducidos != null
                              && punto.UbicacionPalesProducidos.Id !== punto.UbicacionDefectoPalesProducidos.Id"
                            class="div-rectanguloUbicacionDestinoModificada"
                          >
                            <span> UBICACIÓN MOD </span>
                          </div>
                          <div
                            v-if="ObtenerPaleRetrabajadoEnPuntoPaletizado(punto.Id) != null"
                            class="div-rectanguloReabierto "
                          >
                            <span>REABIERTO {{ ObtenerPaleRetrabajadoEnPuntoPaletizado(punto.Id).NumeroSerie }}</span>
                          </div>
                          <span
                            v-if="ObtenerTipoEnvasadoPuntoDePaletizado(punto) != null
                              && partidaEnPuntoDevolcadoSeleccionada != null
                              && partidaEnPuntoDevolcadoSeleccionada.Partida.Articulo.Familia.Id !== ObtenerTipoEnvasadoPuntoDePaletizado(punto).Articulo.Familia.Id"
                            class="oval-informacionAlertaRojo-14 oval-informacionDeAlerta oval-informacionDeAlerta-tarjetaPedido"
                          > ! </span>
                          <span class="btn-oval-azulOscuro-26">{{ ObtenerPedidoAsignadoPuntoDePaletizado(punto).CantidadPalet }}</span>
                        </f7-col>
                      </f7-row>
                      <!-- Fin Cabecera Tarjetas Asignadas con Pedidos -->
                      <!-- Cabecera Tarjeta PP no asignados a Pedidos -->
                      <f7-row
                        v-if="ObtenerPedidoAsignadoPuntoDePaletizado(punto) == null"
                        class="row-cabeceraTarjeta"
                      >
                        <f7-col
                          width="100"
                          class="col-cabeceraDerecha"
                        >
                          <div
                            v-if="ObtenerPaleRetrabajadoEnPuntoPaletizado(punto.Id) != null"
                            class="div-rectanguloReabierto"
                          >
                            <span>REABIERTO {{ ObtenerPaleRetrabajadoEnPuntoPaletizado(punto.Id).NumeroSerie }}</span>
                          </div>
                          <div
                            v-if="punto.UbicacionDefectoPalesProducidos != null
                              && punto.UbicacionPalesProducidos != null
                              && punto.UbicacionPalesProducidos.Id !== punto.UbicacionDefectoPalesProducidos.Id"
                            class="div-rectanguloUbicacionDestinoModificada "
                          >
                            <span> UBICACIÓN MOD </span>
                          </div>
                          <span
                            v-if="ObtenerTipoEnvasadoPuntoDePaletizado(punto) != null
                              && partidaEnPuntoDevolcadoSeleccionada != null
                              && partidaEnPuntoDevolcadoSeleccionada.Partida.Articulo.Familia.Id !== ObtenerTipoEnvasadoPuntoDePaletizado(punto).Articulo.Familia.Id"
                            class="oval-informacionAlertaRojo-14 oval-informacionDeAlerta"
                          > ! </span>
                        </f7-col>
                      </f7-row>
                      <!-- FIN Cabecera Tarjeta PP no asignados a Pedidos -->
                      <f7-row class="row-elementoTarjetaPuntoPaletizado">
                        <f7-col width="10">
                          <span
                            class="btn-oval-verde-46 seleccionable"
                            :class="{ disabled: modoEdicionActivo }"
                            @click="FinalizarPaleEnPuntoDePaletizado(punto, true)"
                          ><img
                            src="@/static/icons/ic_check_off.svg"
                            alt="iconTickOff"
                            width="15px"
                          ></span>
                        </f7-col>
                        <f7-col
                          width="20"
                          class="col-tituloPuntoYTipoEnvasado"
                        >
                          <f7-row>
                            <f7-col width="100">
                              <span class="span-texto-azulOscuro-18-500">{{ punto.Codigo }}</span>
                            </f7-col>
                          </f7-row>
                          <div
                            v-if="ObtenerTipoEnvasadoPuntoDePaletizado(punto) != null"
                            class="div-datosTipoEnvasadoPuntoPaletizado"
                          >
                            <f7-row>
                              <f7-col width="100">
                                <span class="span-texto-gris-14-500">{{ ObtenerTipoEnvasadoPuntoDePaletizado(punto).Articulo.Nombre }}</span>
                              </f7-col>
                            </f7-row>
                          </div>
                        </f7-col>
                        <f7-col width="70">
                          <f7-row>
                            <f7-col
                              width="80"
                              @click="ComprobarSiEsPosibleAñadirMercanciaAlPP(punto)"
                            >
                              <UCUnitMeasureKiloAndContainer
                                :default-envases="ObtenerTotalesKiloEnvasePP(punto).envases"
                                :default-kilos="ObtenerTotalesKiloEnvasePP(punto).kilos"
                                :deshabilitar="(puntoDePaletizadoSeleccionado == null || puntoDePaletizadoSeleccionado.Id !== punto.Id) || ObtenerTipoEnvasadoPuntoDePaletizado(punto) == null"
                                :id-elemento="punto.Id"
                                :tag="punto"
                                plantilla="P2"
                                :autocalculo="true"
                                :envase="tipoEnvasadoPuntoPaletizadoSeleccionado != null ? tipoEnvasadoPuntoPaletizadoSeleccionado.Envase : null"
                                :producto="tipoEnvasadoPuntoPaletizadoSeleccionado != null ? tipoEnvasadoPuntoPaletizadoSeleccionado.Articulo : null"
                                :capacidad-producto-por-envase="capacidadProductoPorEnvaseElementoSeleccionado"
                                :sin-maximo="true"
                                @cantidad-envases-y-kilos-modificada="CantidadKilosEnvasesMoficiada"
                              />
                            </f7-col>

                            <f7-col width="20">
                              <div
                                v-if="!modoEdicionActivo"
                                class="div-opcionesDePuntoPaletizado"
                              >
                                <img
                                  src="@/static/icons/ic_edit_disabled.svg"
                                  alt="iconEdit"
                                  class="seleccionable btn-opcionesDePuntoPaletizado"
                                  @click="MostrarPopupDetalleCantidadEnvasesYKilosPorPartida(punto)"
                                >
                                <img
                                  src="@/static/icons/ic_options_dark.svg"
                                  alt="iconSetting"
                                  class="seleccionable btn-opcionesDePuntoPaletizado"
                                  @click="MostrarPopupEdicionProductoPaletizar(punto)"
                                >
                              </div>
                              <!-- Botones de Confirmación de cantidades modificadas -->
                              <div
                                v-if="puntoDePaletizadoSeleccionado === punto && modoEdicionActivo"
                                class="div-opcionesDePuntoPaletizado"
                              >
                                <div class="btn-base-azulOscuro-28">
                                  <img
                                    src="@/static/icons/btn_cancel.svg"
                                    alt="iconCancel"
                                    class="seleccionable btn-opcionesDePuntoPaletizado"
                                    @click="CancelarEnvasesYKilosModificados()"
                                  >
                                </div>
                                <div
                                  class="btn-base-azulOscuro-28"
                                  :class="{
                                    disabled: kilosModificadosEnEnPuntoDePaletizadoSeleccionado <= 0
                                      || envasesModificadosEnEnPuntoDevolcadoSeleccionada <= 0,
                                  }"
                                >
                                  <img
                                    src="@/static/icons/ic_check_04.svg"
                                    alt="iconDone"
                                    class="seleccionable btn-opcionesDePuntoPaletizado"
                                    @click="ConfirmarEnvasesYKilosModificados()"
                                  >
                                </div>
                              </div>
                            </f7-col>
                          </f7-row>
                        </f7-col>
                      </f7-row>
                    </div>
                  </div>
                </div>
              </div>
            </f7-col>

            <f7-col width="40">
              <span class="span-tituloColumnas">RESUMEN LINEA </span>
              <span
                data-v-48a14169=""
                class="btn-oval-azulOscuro-26 btn-actualizarPartidasYPalesGenerados seleccionable"
                @click="ActualizarPartidasYPalesGenerados()"
              >A</span>
              <div class="div-contenedorPartidasLinea">
                <div class="cabecera">
                  <span class="span-texto-azulOscuro-14-500"> PARTIDAS </span>
                </div>
                <div class="div-contenidoComponentePCPartidasActivasYRecintesLinea">
                  <PCPartidasActivasYRecientesLineaParaPaletizado
                    ref="componentePCPartidasActivasYRecientesLineaParaPaletizado"
                    :mostrar-titulo="false"
                    :envasados-linea-produccion="envasadosLineaProduccion"
                    :punto-paletizado-seleccionado="puntoDePaletizadoSeleccionado"
                    @seleccion-partida="PartidadEnPuntoDeVolcadoSeleccionada"
                  />
                </div>
                <!-- Ver Mas -->
                <div
                  v-if="lineaSeleccionada != null"
                  class="div-verMas seleccionable"
                >
                  <span
                    class="span-verMas display-flex justify-content-center"
                    @click="$refs.componentePCPartidasActivasYRecientesLineaParaPaletizado.VerMasPartidasDeLaColaDeVolcado()"
                  >
                    {{ $t('common.seeMore').toUpperCase() }}
                  </span>
                </div>
              </div>
              <div class="div-contenedorUltimosPalesGenerados">
                <div class="cabecera">
                  <span class="span-texto-azulOscuro-14-500"> ÚLTIMOS PALÉS GENERADOS </span>
                </div>
                <div class="div-contenidoComponentePCUltimosPalesGenerados">
                  <PCUltimosPalesGenerados
                    ref="componentePCUltimosPalesGenerados"
                    :mostrar-titulo="false"
                    :mostrar-buscador="true"
                    :mostrar-btn-retrabajar-pale="true"
                    @reabrir-pale-confeccionado-en-punto-de-paletizado="ReabrirPaleConfeccionadoEnPuntoDePaletizado"
                  />
                </div>
                <!-- Ver Mas -->
                <div
                  v-if="lineaSeleccionada != null && puntoDePaletizadoSeleccionado != null"
                  class="div-verMas seleccionable"
                >
                  <span
                    class="span-verMas display-flex justify-content-center"
                    @click="$refs.componentePCUltimosPalesGenerados.VerMasPales()"
                  >
                    {{ $t('common.seeMore').toUpperCase() }}
                  </span>
                </div>
              </div>
            </f7-col>
          </f7-row>
        </f7-col>
      </f7-row>
    </div>

    <!-- Popup Edición de Tipo Envasado -->
    <f7-popup
      class="edicionProductoPaletizado-popup"
      :opened="popupMostrarPopupEdicionProductoPaletizar"
      @popup:closed="popupMostrarPopupEdicionProductoPaletizar = false"
    >
      <f7-navbar
        :title="$t('EdicionDePaletizado')"
        sliding
        :style="appTheme"
      >
        <f7-nav-right>
          <f7-link @click="popupMostrarPopupEdicionProductoPaletizar = false">
            {{ $t('common.x') }}
          </f7-link>
        </f7-nav-right>
      </f7-navbar>
      <FrmEditionSelectionPreparationCalibration
        :activo="popupMostrarPopupEdicionProductoPaletizar"
        :mostrar-navbar-frm="false"
        :app-theme="appTheme"
        @cerrar-frm="popupMostrarPopupEdicionProductoPaletizar = false"
        @tipo-envasado-actualizado="TipoEnvasadoEnPuntoPaletizadoModificado()"
        @pedido-establecido="PedidoEstablecidoParaPuntoDePaletizado()"
        @ubicacion-pales-producidos-modificada="UbicacionPalesProducidosPuntoPaletizadoModificada"
        @eliminar-pale-para-retrabajo-asignado="EliminarPaleParaRetrabajoAsignadoEnPuntoDePaletizadoSeleccionado()"
      />
    </f7-popup>

    <!-- Popup Plantillas Confeccion Familia -->
    <f7-popup
      class="edicionProductoPaletizado-popup"
      :opened="popupMostrarPopupModelosParaPuntosDePaletizado"
      @popup:closed="popupMostrarPopupModelosParaPuntosDePaletizado = false"
    >
      <f7-navbar
        :title="$t('PlantillasConfeccion')"
        sliding:style="appTheme"
      >
        <f7-nav-right>
          <f7-link @click="popupMostrarPopupModelosParaPuntosDePaletizado = false">
            {{ $t('common.x') }}
          </f7-link>
        </f7-nav-right>
      </f7-navbar>
      <FrmFamilyPreparationTemplatesModels
        :activo="popupMostrarPopupModelosParaPuntosDePaletizado"
        :mostrar-navbar-frm="false"
        @cerrar-frm="popupMostrarPopupModelosParaPuntosDePaletizado = false"
        @plantillas-tipo-envasado-actualizadas="PlantillasTipoEnvasadoActualizadas"
      />
    </f7-popup>

    <!-- Detalle Palé -->
    <f7-popup
      class="detallePale-popup"
      :opened="popupDetalleCantidadEnvasesYKilosPorPartida"
      @popup:closed="popupDetalleCantidadEnvasesYKilosPorPartida = false"
    >
      <f7-navbar
        :title="$t('production.common.palletDetail')"
        sliding
        :style="appTheme"
      >
        <f7-nav-right>
          <f7-link @click="popupDetalleCantidadEnvasesYKilosPorPartida = false">
            {{ $t('common.x') }}
          </f7-link>
        </f7-nav-right>
      </f7-navbar>

      <div
        v-if="popupDetalleCantidadEnvasesYKilosPorPartida
          && ObtenerTipoEnvasadoPuntoDePaletizado(puntoDePaletizadoSeleccionado) != null
          && partidaEnPuntoDevolcadoSeleccionada != null
          && partidaEnPuntoDevolcadoSeleccionada.Partida.Articulo.Familia.Id !== ObtenerTipoEnvasadoPuntoDePaletizado(puntoDePaletizadoSeleccionado).Articulo.Familia.Id"
        class="div-mensajeInformacionDeLaConfeccion"
      >
        <div class="row">
          <div class="col-5">
            <span class="oval-informacionAlertaRojo-14">!</span>
          </div>
          <div class="col-95">
            <span class="span-texto-azulOscuro-14-500"> {{ $t('LaPartidaNoCorrespondeConLafamiliaMensaje') }} </span>
          </div>
        </div>
      </div>

      <div
        v-if="popupDetalleCantidadEnvasesYKilosPorPartida"
        class="div-elementosFrm"
      >
        <div
          v-for="(envasadoPale, index) in envasadosLineaProduccionCLONParaEdicion"
          :key="index"
          class="div-existenciaDelPale"
        >
          <f7-row v-if="envasadoPale != null && puntoDePaletizadoSeleccionado != null && envasadoPale.PuntoDePaletizado.Id === puntoDePaletizadoSeleccionado.Id">
            <f7-col width="40">
              <f7-row>
                <f7-col width="100">
                  <span
                    v-if="envasadoPale.Partida != null"
                    class="span-texto-azulOscuro-18-500"
                  > PARTIDA: {{ `${envasadoPale.Partida.Serie}/${FormatearIdentificadorPartida(envasadoPale.Partida.Numero)}` }}</span>
                </f7-col>
              </f7-row>
              <f7-row>
                <f7-col width="100">
                  <span class="span-texto-gris-14-500">{{ envasadoPale.TipoEnvasado.Articulo.Nombre }}</span>
                </f7-col>
              </f7-row>
              <f7-row>
                <f7-col width="100">
                  <span class="span-texto-gris-14-500">{{ envasadoPale.TipoEnvasado.Envase.Nombre }}</span>
                </f7-col>
              </f7-row>
            </f7-col>
            <f7-col width="60">
              <f7-row>
                <f7-col width="80">
                  <f7-row>
                    <f7-col
                      width="50"
                      class="textoCentrado"
                    >
                      <f7-row>
                        <f7-col width="100">
                          <span class="span-ttlcantidadesDetalle">
                            {{ $t('common.packages').toUpperCase() }}
                          </span>
                        </f7-col>
                      </f7-row>
                      <f7-row>
                        <f7-col
                          width="100"
                          class="col-cantidadesDetalle"
                        >
                          <span class="span-cantidadesDetalle">{{ envasadoPale.CantidadEnvases }}</span>
                        </f7-col>
                      </f7-row>
                    </f7-col>
                    <f7-col
                      width="50"
                      class="textoCentrado"
                    >
                      <f7-row>
                        <f7-col width="100">
                          <span class="span-ttlcantidadesDetalle">{{ $t('common.kilos').toUpperCase() }}</span>
                        </f7-col>
                      </f7-row>
                      <f7-row>
                        <f7-col
                          width="100"
                          class="col-cantidadesDetalle"
                        >
                          <span class="span-cantidadesDetalle">{{ envasadoPale.CantidadKilos }}</span>
                        </f7-col>
                      </f7-row>
                    </f7-col>
                  </f7-row>
                </f7-col>
                <f7-col width="20">
                  <div class="">
                    <div
                      class=" btn-action-group btn-base-rojo-1"
                      @click="ConfirmarEliminarRegistroEnvasadoEnPale(envasadoPale)"
                    >
                      <img
                        alt="iconDelett"
                        src="@/static/icons/ic_trash_white_2.svg"
                      >
                    </div>
                  </div>
                </f7-col>
              </f7-row>
            </f7-col>
          </f7-row>
        </div>

        <div class="div-elementoSeparador-90 div-separador" />
        <div class="div-opcionesActions">
          <f7-row>
            <f7-col
              width="50"
              class="col-izquierdaActions"
            >
              <a
                class="link link-izquierdaActions-2"
                @click="CancelarEdicion()"
              > {{ $t('common.cancel').toUpperCase() }}</a>
            </f7-col>
            <f7-col
              width="50"
              class="col-derechaActions"
            >
              <a
                class="link link-derechaActions-2"
                @click="ConfirmarEdicion()"
              > {{ $t('common.confirm').toUpperCase() }} </a>
            </f7-col>
          </f7-row>
        </div>
      </div>
    </f7-popup>

    <!-- Configuración del formulario MultiPunto -->
    <f7-popup
      class="popup-ConfiguracionMultiPunto"
      :opened="popupConfiguracionPaletizadoMultiple"
      @popup:closed="popupConfiguracionPaletizadoMultiple = false"
    >
      <f7-navbar
        :title="$t('ConfiguracionPaletizadoMultiple')"
        sliding
        :style="appTheme"
      >
        <f7-nav-right>
          <f7-link @click="popupConfiguracionPaletizadoMultiple = false">
            {{ $t('common.x') }}
          </f7-link>
        </f7-nav-right>
      </f7-navbar>
      <div>
        <!-- Cabecera Formulario -->
        <div class="div-configuracionMultiPunto-cabeceraFormulario">
          <f7-row class="">
            <f7-col width="60">
              <span class="span-texto-gris-14-500"> {{ $t('ConfiguracionDelFormulario').toUpperCase() }}: </span>
            </f7-col>

            <f7-col
              width="40"
              class="col-opcionesDerecha"
            >
              <div
                class="div-btnRestablecerFrm seleccionable"
                @click="SolicitudRestablecerFormularioPaletizadoMultiple()"
              >
                <span> {{ $t('RestablecerFormulario').toUpperCase() }} </span>
              </div>
            </f7-col>
          </f7-row>
        </div>
      </div>
    </f7-popup>

    <!-- Action Confirmación Pedido con palés reservados -->
    <f7-actions
      id="actions-ConfirmarPedidoConPalesReservados"
      class="actions-1"
      :opened="actionConfirmarPedidoConPalesReservados"
      @actions:closed="actionConfirmarPedidoConPalesReservados = false"
    >
      <div v-if="actionConfirmarPedidoConPalesReservados">
        <div class="div-actionsTitulo-2">
          <span class="">
            {{ $t('production.palletizing.labels.reservedPallets').toUpperCase() }}
          </span>
        </div>
        <f7-actions-label class="text-align-center">
          <!-- El pedido seleccionado tiene palés reservados -->
          {{ valorMensajeDeConfirmacion }}
        </f7-actions-label>
        <div class="div-elementoSeparador-90" />

        <!-- Pie de  Boton Opciones -->
        <div class="div-opcionesActions">
          <f7-row>
            <f7-col
              width="50"
              class="col-izquierdaActions"
            >
              <a
                class="link link-izquierdaActions-1"
                @click="actionConfirmarPedidoConPalesReservados = false"
              >
                {{ $t('common.cancel').toUpperCase() }}
              </a>
            </f7-col>
            <f7-col
              width="50"
              class="col-derechaActions"
            >
              <a
                class="link link-derechaActions-1"
                @click="actionConfirmarPedidoConPalesReservados = false;FinalizarPaleEnPuntoDePaletizado(punto, false)"
              >
                {{ $t('common.continue').toUpperCase() }}
              </a>
            </f7-col>
          </f7-row>
        </div>
      </div>
    </f7-actions>
  </f7-page>
</template>

<script>
import { mapState, mapWritableState } from 'pinia';
import { useTraceabilityStore } from '@/js/stores/traceability';
import { useParamRef } from '@erpagroapp/params';
import { useSettingRef } from '@erpagroapp/settings';

import { Log, LogError } from '@/js/common/HIDebuggingSupport';
import {
  ConfirmDialogGH,
  HiDialog,
  HiNotification,
  PreloaderGH,
} from '@/js/common/HINotificationSupport';
import ConexionTA from '@/js/services/traceability/APITraceability';
import PCPartidasActivasYRecientesLineaParaPaletizado from '@/components/production/traceability/PCPartidasActivasYRecientesLineaParaPaletizado.vue';
import PCUltimosPalesGenerados from '@/components/production/traceability/PCUltimosPalesGenerados.vue';
import FrmEditionSelectionPreparationCalibration from '@/pages/production/traceability/palletizing/FrmEditionSelectionPreparationCalibration.vue';
import FrmFamilyPreparationTemplatesModels from '@/pages/production/traceability/palletizing/FrmFamilyPreparationTemplatesModels.vue';
import { sleep } from '@/js/utils/sleep';
import SoporteNumeracion from '@/js/common/HiNumerationSupport';
import { LOGO_HISPATEC } from '@/js/common/constants';
import UCPreload from '@/components/common/UCPreload.vue';
import UCUnitMeasureKiloAndContainer from '@/components/common/UCUnitMeasureKiloAndContainer.vue';
import UCSearchEntityERP from '@/components/common/UCSearchEntityERP.vue';
import PCSideNavbar from '@/components/common/PCSideNavbar.vue';
import { f7 } from 'framework7-vue';
import { useSortedProductionLines } from '@/composables/useSortedProductionLines';

/** @import { SideNavbarItem } from '@/composables/useSideNavbar' */

export default {
  name: 'FrmMultipointPalletizing',
  components: {
    UCSearchEntityERP,
    UCUnitMeasureKiloAndContainer,
    PCPartidasActivasYRecientesLineaParaPaletizado,
    PCUltimosPalesGenerados,
    FrmEditionSelectionPreparationCalibration,
    FrmFamilyPreparationTemplatesModels,
    UCPreload,
    PCSideNavbar,

  },

  setup() {
    const { sortedProductionLines } = useSortedProductionLines();
    return {
      sortedProductionLines,
    };
  },

  data() {
    return {
      lineaSeleccionada: null, // Mantiene la linea seleccionada.
      puntosDePaletizado: null, // Mantiene los puntos de paletizado de la linea de produccion selecctionada.
      popupConfiguracionPaletizadoMultiple: false, // Controla la apertura del popup.
      popupDetalleCantidadEnvasesYKilosPorPartida: false, // Controla la apertura del popup.
      popupMostrarPopupEdicionProductoPaletizar: false, // Controla la apertura del popup.
      popupMostrarPopupModelosParaPuntosDePaletizado: false, // Controla la apertura del popup de modelos.
      actionConfirmarPedidoConPalesReservados: false, // Controla la apertura del actión que informa si se supera el número de pales reservados del pedido.
      mostrarPrecarga: false,
      modoEdicionActivo: false, // Controla si se modifico la cantidad de envases y Kilos de el punto de paletizado seleccionado.
      partidaEnPuntoDevolcadoSeleccionada: false, // Contiene la entidad partidadEnPuntoDevolcado seleccionada. (partida volcada con información en un punto de paletizado)
      envasadosLineaProduccion: null, // Contiene las cantidades de envases y kilos por partida de los puntos de paletizado de la linea seleccionada
      tiposEnvasadoPuntosDePaletizado: null, // Contiene los tipos de envasado configurados en los puntos de paletizado.
      pedidosAsignadosPuntosDePaletizado: null, // Contiene los posibles pedidos asignados en puntos de paletizado.
      palesActivosEnPuntosDePaletizado: null, // Contiene una relación entre los puntos de paletizado y el palé activo.
      kilosModificadosEnEnPuntoDePaletizadoSeleccionado: 0, // Mantiene la ultima modificación realizada de kilos en un punto.
      envasesModificadosEnEnPuntoDevolcadoSeleccionada: 0, // Mantiene la ultima modificación realizada de envases en un punto.
      registroEnvasadoPaleSeleccionado: null, // Registro envasado seleccionado en la ventana de edición.
      envasadosLineaProduccionCLONParaEdicion: null, // Mantiene una copia de palesActivosEnPuntosDePaletizado si se confirma la modificación se reemplaza.
      tipoEnvasadoPuntoPaletizadoSeleccionado: null, // Mantiene el tipo de envasado del punto de paletizado seleccionado.
      lineaSeleccionadaAlIniciarFormulario: null, // Mantiene la ultima linea seleccionada en este o otros frm para que cuando se abra el frm carge la ultima.
      valorMensajeDeConfirmacion: '', // Mantiene el valor del ultimo mensaje de confirmación
      verificarReservaDePalesAntesDeGeneraNuevoPaleDePedido: false, // Si se establece a true antes de iniciar un nuevo palé de un pedido se verificara el número de reservas de pales de la linea de pedido no supere el total.
      contadorDeLlamadasPendientesDeRespuestaEnFrm: 0, // Controla el número de llamadas al WS que se estan realizando en el frm sin respuesta.
      lineasProduccion: null,
      LOGO_HISPATEC,
      restaurarTipoEnvasadoPaletizadoMultiple: useParamRef('RestaurarTipoEnvasadoPaletizadoMultiple'),
      logoApp: useSettingRef('App.Logo'),
    };
  },

  computed: {
    ...mapState(useTraceabilityStore, [
      'lineasDeProduccionDelUsuarioDefinidaEnERP',
    ]),

    ...mapWritableState(useTraceabilityStore, [
      'lineaDeProduccionSeleccionada',
      'puntoDePaletizadoSeleccionado',
      'pedidoPlanificadoSeleccionado',
      'tipoEnvasadoElementoProduccionSeleccionado',
      'coleccionMercanciaIncluidaEnPale',
      'coleccionTiposDeEnvasadosEstablecidosEnLosPuntosDePaletizado',
      'coleccionPedidosAsignadosEnPuntosDePaletizado',
      'partidaSeleccionada',
      'paleEnRetrabajoPuntoPaletizadoSeleccionado',
    ]),

    appTheme() {
      return {
        '--f7-navbar-bg-color': 'var(--his-plum-shadow)',
        '--f7-navbar-text-color': '#fff',
      };
    },
    capacidadProductoPorEnvaseElementoSeleccionado() {
      if (this.tipoEnvasadoPuntoPaletizadoSeleccionado != null) {
        return this.ObtenerCapacidadEnvasePuntoDePaletizado(this.puntoDePaletizadoSeleccionado);
      }
      return 1; // Por defecto siempre sera 1.
    },
  },

  watch: {
    envasadosLineaProduccion(val) {
      this.coleccionMercanciaIncluidaEnPale = val; // Almacenamos en la variable global para posibles recuperaciones.
    },
    tiposEnvasadoPuntosDePaletizado(val) {
      this.coleccionTiposDeEnvasadosEstablecidosEnLosPuntosDePaletizado = val; // Almacenamos en la variable global para posibles recuperaciones.
    },
    pedidosAsignadosPuntosDePaletizado(val) {
      this.coleccionPedidosAsignadosEnPuntosDePaletizado = val; // Almacenamos en la variable global para posibles recuperaciones.
    },
  },
  mounted() {
    this.IncializarFrm();
  },

  methods: {
    IncializarFrm() {
      Log(this, this.IncializarFrm.name);
      // Sol.221815  - Cuando salgo para volcar y vuelvo a entrar en el paletizado, debe seguir cargada la última línea que estuvo seleccionada.

      // sol.222038 - Si lineaSeleccionadaAlIniciarFormulario es null obtenemos la linea por defecto definida en el trabajador.
      this.lineaSeleccionadaAlIniciarFormulario = this.lineaDeProduccionSeleccionada;
      // sol.222038 - Si lineaSeleccionadaAlIniciarFormulario es null obtenemos la linea por defecto definida en el trabajador.
      this.lineaSeleccionadaAlIniciarFormulario ??= this.lineasDeProduccionDelUsuarioDefinidaEnERP;

      this.lineasProduccion = this.sortedProductionLines;
      if (this.lineaSeleccionadaAlIniciarFormulario) {
        this.puntosDePaletizado = { ...this.lineaSeleccionadaAlIniciarFormulario.PuntosDePaletizado };
      }

      this.lineaSeleccionada = this.lineaSeleccionadaAlIniciarFormulario;
      this.LineaProduccionSeleccionada(this.lineaSeleccionada);

      // Revisamos si ya tenemos mercancia incluida en Palé que aún no esta sincronizada.
      this.envasadosLineaProduccion = this.coleccionMercanciaIncluidaEnPale;
      this.tiposEnvasadoPuntosDePaletizado = this.coleccionTiposDeEnvasadosEstablecidosEnLosPuntosDePaletizado;
      this.pedidosAsignadosPuntosDePaletizado = this.coleccionPedidosAsignadosEnPuntosDePaletizado;

      // this.puntosDePaletizado = this.lineasProduccion.PuntosDePaletizado;
    },

    async LineaProduccionSeleccionada(lineaSeleccionada) {
      Log(this, this.LineaProduccionSeleccionada.name);
      if (lineaSeleccionada != null) {
        this.lineaDeProduccionSeleccionada = lineaSeleccionada;
      }
      const self = this;
      this.mostrarPrecarga = true;
      this.lineaSeleccionada = lineaSeleccionada;
      this.puntoDePaletizadoSeleccionado = null;
      this.modoEdicionActivo = false;
      this.partidaEnPuntoDevolcadoSeleccionada = null;
      this.puntosDePaletizado = null;
      this.$refs.componentePCUltimosPalesGenerados.RestablecerValores();
      if (lineaSeleccionada == null) {
        this.puntosDePaletizado = null;
        this.$refs.componentePCPartidasActivasYRecientesLineaParaPaletizado.RestablecerValores();
        this.modoEdicionActivo = false;
        this.mostrarPrecarga = false;
        return;
      }
      this.$refs.componentePCPartidasActivasYRecientesLineaParaPaletizado.ActualizarDatos();

      await this.ObtenerPalesActivosEnLineaProduccion().then((result) => {
        self.palesActivosEnPuntosDePaletizado = result;
        self.puntosDePaletizado = self.lineaSeleccionada.PuntosDePaletizado;
      }).catch((error) => {
        LogError(this, this.LineaProduccionSeleccionada.name, error);
      }).finally(() => {
        self.mostrarPrecarga = false;
      });
      if (self.puntosDePaletizado.length === 0) {
        HiNotification.Toast(this.$t('LineaSinPuntos'));
      }
    },

    MostrarPopupDetalleCantidadEnvasesYKilosPorPartida(puntoSeleccionado) {
      Log(this, this.MostrarPopupDetalleCantidadEnvasesYKilosPorPartida.name);
      this.puntoDePaletizadoSeleccionado = puntoSeleccionado;
      const tempExistenciasDelPale = this.ObtenerExistenciasIncluidasEnPale(this.puntoDePaletizadoSeleccionado);
      if (tempExistenciasDelPale != null && tempExistenciasDelPale.length > 0) {
        this.popupDetalleCantidadEnvasesYKilosPorPartida = true;
        this.envasadosLineaProduccionCLONParaEdicion = Object.assign([], this.envasadosLineaProduccion); //  Clonamos  el array []
      } else {
        HiNotification.Toast(this.$t('PaleSinMercancia'));
      }
    },

    MostrarPopupEdicionProductoPaletizar(puntoSeleccionado) {
      Log(this, this.MostrarPopupEdicionProductoPaletizar.name);
      this.puntoDePaletizadoSeleccionado = puntoSeleccionado;
      const tempPedidoAsignadoEnPuntoPaletizado = this.ObtenerPedidoAsignadoPuntoDePaletizado(this.puntoDePaletizadoSeleccionado);
      const tempTipoEnvasadoPuntoPaletizado = this.ObtenerTipoEnvasadoPuntoDePaletizado(this.puntoDePaletizadoSeleccionado);
      const tempPosiblePaleRetrabajadoEnPuntoPaletizado = this.ObtenerPaleRetrabajadoEnPuntoPaletizado(this.puntoDePaletizadoSeleccionado.Id);
      this.pedidoPlanificadoSeleccionado = tempPedidoAsignadoEnPuntoPaletizado;
      this.tipoEnvasadoElementoProduccionSeleccionado = tempTipoEnvasadoPuntoPaletizado;
      this.paleEnRetrabajoPuntoPaletizadoSeleccionado = tempPosiblePaleRetrabajadoEnPuntoPaletizado;
      this.popupMostrarPopupEdicionProductoPaletizar = true;
    },

    PuntoPaletizadoSeleccionado(punto) {
      Log(this, this.PuntoPaletizadoSeleccionado.name);
      if (this.puntoDePaletizadoSeleccionado === punto) {
        return;
      }

      if (this.modoEdicionActivo) {
        HiNotification.Toast(this.$t('DescartarCambiosCantidadesPedido'));
        return;
      }
      this.puntoDePaletizadoSeleccionado = punto;
      this.tipoEnvasadoPuntoPaletizadoSeleccionado = this.ObtenerTipoEnvasadoPuntoDePaletizado(punto);
      this.$refs.componentePCUltimosPalesGenerados.ActualizarDatos(true);
    },

    CantidadKilosEnvasesMoficiada(params) {
      Log(this, this.CantidadKilosEnvasesMoficiada.name);

      // Comprobamos que dispongamos de tipoenvadado establecido en el punto.
      if (this.ObtenerTipoEnvasadoPuntoDePaletizado(this.puntoDePaletizadoSeleccionado) == null) {
        return;
      }
      if (this.popupDetalleCantidadEnvasesYKilosPorPartida) {
        LogError('Solo se puede modificar cuando el popupDetalle esta CERRADO');
        return;
      }

      if (this.puntoDePaletizadoSeleccionado != null) {
        this.modoEdicionActivo = true;
        this.kilosModificadosEnEnPuntoDePaletizadoSeleccionado = params.CantidadKilosModificado;
        this.envasesModificadosEnEnPuntoDevolcadoSeleccionada = params.CantidadEnvasesModificado;
      }
    },

    ConfirmarEnvasesYKilosModificados() {
      Log(this, this.ConfirmarEnvasesYKilosModificados.name);
      if (this.partidaEnPuntoDevolcadoSeleccionada == null) {
        HiNotification.Toast(this.$t('NecesarioSeleccionarPartida'));
        return;
      }
      // Obtenemos los envases totales del palé y los Kilos ya existentes para conocer lo nuevo que se añade.
      let tempKilosEnvasadosPunto = 0; // Contendra lo existente antes de añadir lo nuevo
      let tempEnvasesEnvasadosPunto = 0; // Contendra lo existente antes de añadir lo nuevo
      let tempKilosSumados = 0; // Contendra lo nuevo sumado.
      let tempEnvasesSumados = 0; // Contendra lo nuevo sumado.
      if (this.envasadosLineaProduccion != null) {
        const tempEnvasadosPaleDePunto = this.envasadosLineaProduccion.filter((e) => e.PuntoDePaletizado.Id === this.puntoDePaletizadoSeleccionado.Id);
        tempEnvasadosPaleDePunto.forEach((envasado) => {
          tempKilosEnvasadosPunto = Number(tempKilosEnvasadosPunto) + Number(envasado.CantidadKilos);
          tempEnvasesEnvasadosPunto = Number.parseInt(tempEnvasesEnvasadosPunto, 10) + Number.parseInt(envasado.CantidadEnvases, 10);
        });

        // La cantidad actual no puede ser inferior a la ya existente.
        if (Number.parseInt(this.envasesModificadosEnEnPuntoDevolcadoSeleccionada, 10) <= Number.parseInt(tempEnvasesEnvasadosPunto, 10)) {
          HiNotification.Toast(this.$t('CantidadEnvasesInferiorExistentePale'));
          return;
        }
        if (Number(this.kilosModificadosEnEnPuntoDePaletizadoSeleccionado) <= Number(tempKilosEnvasadosPunto)) {
          HiNotification.Toast(this.$t('CantidadKilosInferiorExistentePale'));
          return;
        }

        tempKilosSumados = Number(this.kilosModificadosEnEnPuntoDePaletizadoSeleccionado) - Number(tempKilosEnvasadosPunto);
        tempEnvasesSumados = Number.parseInt(this.envasesModificadosEnEnPuntoDevolcadoSeleccionada, 10) - Number.parseInt(tempEnvasesEnvasadosPunto, 10);
      } else {
        tempKilosSumados = this.kilosModificadosEnEnPuntoDePaletizadoSeleccionado;
        tempEnvasesSumados = this.envasesModificadosEnEnPuntoDevolcadoSeleccionada;
      }
      const tempTipoEnvasadoPuntoPaletizado = this.ObtenerTipoEnvasadoPuntoDePaletizado(this.puntoDePaletizadoSeleccionado);
      // Comprobamos que la partida que se añade se corresponde con la familia que vamos a añadir.
      if (tempTipoEnvasadoPuntoPaletizado.Articulo.Familia != null && tempTipoEnvasadoPuntoPaletizado.Articulo.Familia !== undefined) {
        if (tempTipoEnvasadoPuntoPaletizado.Articulo.Familia.Id !== this.partidaEnPuntoDevolcadoSeleccionada.Partida.Articulo.Familia.Id) {
          HiNotification.Toast(this.$t('EnvasesNoIncluidosFamiliaErronea'));
          // Restablecemos y actualizamos.
          this.modoEdicionActivo = false;
          this.kilosModificadosEnEnPuntoDePaletizadoSeleccionado = 0;
          this.envasesModificadosEnEnPuntoDevolcadoSeleccionada = 0;
          this.puntoDePaletizadoSeleccionado = null;
          this.ActualizarListadoPuntosDePaletizado();
          return;
        }
      }
      this.IncluirRegistroEnvadadoEnPuntoDePaletizado(tempTipoEnvasadoPuntoPaletizado, tempEnvasesSumados, tempKilosSumados, this.partidaEnPuntoDevolcadoSeleccionada.Partida, false);
      // Realizamos la impresión de la etiqueta.
      this.ImprimirEtiquetaIncluirPartidaEnPaleDePuntoPaletizado(this.puntoDePaletizadoSeleccionado.Id, this.partidaEnPuntoDevolcadoSeleccionada.Partida.Id, tempTipoEnvasadoPuntoPaletizado.Envase.Id, tempKilosSumados, tempEnvasesSumados);
      // Restablecemos y actualizamos.
      this.modoEdicionActivo = false;
      this.kilosModificadosEnEnPuntoDePaletizadoSeleccionado = 0;
      this.envasesModificadosEnEnPuntoDevolcadoSeleccionada = 0;
      this.puntoDePaletizadoSeleccionado = null;
      this.ActualizarListadoPuntosDePaletizado();
      this.$refs.componentePCPartidasActivasYRecientesLineaParaPaletizado.ActualizarDatos(true);
    },

    IncluirRegistroEnvadadoEnPuntoDePaletizado(tempTipoEnvasadoPuntoPaletizado, tempEnvasesSumados, tempKilosSumados, partidaOrigen, movimientoDePaleRetrabajado) {
      Log(this, this.IncluirRegistroEnvadadoEnPuntoDePaletizado.name);
      const tempEnvasado = {
        LineaDeProduccion: {
          Id: this.lineaSeleccionada.Id,
        },
        PuntoDePaletizado: this.puntoDePaletizadoSeleccionado,
        Partida: partidaOrigen,
        CantidadEnvases: Number.parseInt(tempEnvasesSumados, 10),
        CantidadKilos: Number(tempKilosSumados),
        TipoEnvasado: tempTipoEnvasadoPuntoPaletizado,
        MovimientoDeRetrabajo: movimientoDePaleRetrabajado,
      };
      if (this.envasadosLineaProduccion === null) {
        this.envasadosLineaProduccion = [];
      }

      // Comprobamos si existe para la misma partida con el mismo tipo de envasado lo metemos en el mismo registro.
      const tempIndexRegistroEnvasado = this.ExisteRegistroEnvasadoDelMismoTipoEnElPuntoDePaletizado(tempEnvasado);
      if (tempIndexRegistroEnvasado === -1) {
        this.envasadosLineaProduccion.push(tempEnvasado);
      } else {
        this.envasadosLineaProduccion[tempIndexRegistroEnvasado].CantidadKilos += tempEnvasado.CantidadKilos;
        this.envasadosLineaProduccion[tempIndexRegistroEnvasado].CantidadEnvases += tempEnvasado.CantidadEnvases;
      }
    },

    // Si lo encuentra retorna su posicion, en caso contrario -1
    ExisteRegistroEnvasadoDelMismoTipoEnElPuntoDePaletizado(envasadoBuscado) {
      Log(this, this.ExisteRegistroEnvasadoDelMismoTipoEnElPuntoDePaletizado.name);
      const tempIndexEnvasadoLP = this.envasadosLineaProduccion.findIndex((e) => e.PuntoDePaletizado.Id === envasadoBuscado.PuntoDePaletizado.Id
        && e.Partida.Id === envasadoBuscado.Partida.Id
        && e.TipoEnvasado.Articulo.Id === envasadoBuscado.TipoEnvasado.Articulo.Id
        && e.TipoEnvasado.Envase.Id === envasadoBuscado.TipoEnvasado.Envase.Id);
      return tempIndexEnvasadoLP;
    },

    CancelarEnvasesYKilosModificados() {
      Log(this, this.CancelarEnvasesYKilosModificados.name);
      this.modoEdicionActivo = false;
      this.puntoDePaletizadoSeleccionado = null;
      this.kilosModificadosEnEnPuntoDePaletizadoSeleccionado = 0;
      this.envasesModificadosEnEnPuntoDevolcadoSeleccionada = 0;
      this.ActualizarListadoPuntosDePaletizado();
    },

    PartidadEnPuntoDeVolcadoSeleccionada(partidaEnPuntoDevolcado) {
      Log(this, this.PartidadEnPuntoDeVolcadoSeleccionada.name);
      this.partidaEnPuntoDevolcadoSeleccionada = partidaEnPuntoDevolcado;
      this.partidaSeleccionada = partidaEnPuntoDevolcado; // Establecemos la vatiable global.
    },

    FormatearIdentificadorPartida(identificadorPartida) {
      return SoporteNumeracion.EstablecerLogitudFija(identificadorPartida, 7);
    },

    ModificadoEnvasadoPale(params) {
      Log(this, this.ModificadoEnvasadoPale.name);
      // Buscamos envasado modificado segun el tag recibido.
      const elementoModificado = params.Tag;
      const nuevaCantidadKilos = Number.parseInt(params.CantidadKilosModificado, 10);
      const nuevaCantidadEnvases = Number.parseInt(params.CantidadEnvasesModificado, 10);
      this.envasadosLineaProduccionCLONParaEdicion.find((e) => (e.Partida.Id === elementoModificado.Partida.Id)).CantidadKilos = nuevaCantidadKilos;
      this.envasadosLineaProduccionCLONParaEdicion.find((e) => (e.Partida.Id === elementoModificado.Partida.Id)).CantidadEnvases = nuevaCantidadEnvases;
    },

    ObtenerTotalesKiloEnvasePP(puntoPaletizado) {
      Log(this, this.ObtenerTotalesKiloEnvasePP.name);
      // Obtenemos los envases totales del palé y los Kilos ya existentes para conocer lo nuevo que se añade.
      let tempKilosEnvasadosPunto = 0; // Contendra lo existente antes de añadir lo nuevo
      let tempEnvasesEnvasadosPunto = 0; // Contendra lo existente antes de añadir lo nuevo
      if (this.envasadosLineaProduccion != null) {
        const tempEnvasadosPaleDePunto = this.envasadosLineaProduccion.filter((e) => e.PuntoDePaletizado.Id === puntoPaletizado.Id);
        tempEnvasadosPaleDePunto.forEach((envasado) => {
          tempKilosEnvasadosPunto = Number(tempKilosEnvasadosPunto) + Number(envasado.CantidadKilos);
          tempEnvasesEnvasadosPunto = Number.parseInt(tempEnvasesEnvasadosPunto, 10) + Number.parseInt(envasado.CantidadEnvases, 10);
        });
      } else {
        tempKilosEnvasadosPunto = 0;
        tempEnvasesEnvasadosPunto = 0;
      }
      const result = {
        envases: tempEnvasesEnvasadosPunto,
        kilos: tempKilosEnvasadosPunto,

      };

      return result;
    },

    ActualizarListadoPuntosDePaletizado() {
      Log(this, this.ActualizarListadoPuntosDePaletizado.name);
      const tempPuntosDePaletizado = this.puntosDePaletizado;
      this.puntosDePaletizado = null;
      sleep(1).then(() => {
        this.puntosDePaletizado = tempPuntosDePaletizado;
        this.puntoDePaletizadoSeleccionado = null;
      });
    },

    TipoEnvasadoEnPuntoPaletizadoModificado() {
      Log(this, this.TipoEnvasadoEnPuntoPaletizadoModificado.name);
      const tempTipoEnvasadoElementoProduccionSeleccionadoActualizado = { ...this.tipoEnvasadoElementoProduccionSeleccionado };
      const tempPosiblePaleRetrabajadoEnPuntoPaletizado = this.ObtenerPaleRetrabajadoEnPuntoPaletizado(this.puntoDePaletizadoSeleccionado.Id);
      this.tipoEnvasadoPuntoPaletizadoSeleccionado = tempTipoEnvasadoElementoProduccionSeleccionadoActualizado;
      this.AsignarTipoEnvasadoPuntoPaletizado(this.puntoDePaletizadoSeleccionado, tempTipoEnvasadoElementoProduccionSeleccionadoActualizado, tempPosiblePaleRetrabajadoEnPuntoPaletizado);
    },

    ObtenerPaleRetrabajadoEnPuntoPaletizado(idPuntoPaletizado) {
      Log(this, this.ObtenerPaleRetrabajadoEnPuntoPaletizado.name);
      if (this.tiposEnvasadoPuntosDePaletizado == null) {
        return null;
      }
      const tempInfoPuntoPaletizado = this.tiposEnvasadoPuntosDePaletizado.find((t) => t.PuntoPaletizado.Id === idPuntoPaletizado);
      if (tempInfoPuntoPaletizado !== undefined) {
        return tempInfoPuntoPaletizado.PaleEnRetrabajo;
      }
      return null;
    },

    async AsignarTipoEnvasadoPuntoPaletizado(objPuntoPaletizado, objTipoEnvasado, objPaleEnRetrabajo) {
      Log(this, this.AsignarTipoEnvasadoPuntoPaletizado.name);
      const capacidadProductoPorEnvase = await this.ObtenerCantidadDeKilosPorEnvaseDeUnProducto(objTipoEnvasado.Articulo, objTipoEnvasado.Envase);
      // Comprobamos si ya existe un tipo de envasado en para el punto (Actualizamos o Creamos)
      if (this.tiposEnvasadoPuntosDePaletizado == null) {
        this.tiposEnvasadoPuntosDePaletizado = [];
        this.tiposEnvasadoPuntosDePaletizado.push({
          PuntoPaletizado: objPuntoPaletizado,
          TipoEnvasadoElementoProduccion: objTipoEnvasado,
          PaleEnRetrabajo: objPaleEnRetrabajo,
          CapacidadProductoPorEnvase: capacidadProductoPorEnvase,
        });
        // return;
      } else {
        const tempIndexTipoEnvasadoPuntoPaletizado = this.tiposEnvasadoPuntosDePaletizado.findIndex((t) => t.PuntoPaletizado.Id === objPuntoPaletizado.Id);
        if (tempIndexTipoEnvasadoPuntoPaletizado !== -1) {
          this.tiposEnvasadoPuntosDePaletizado[tempIndexTipoEnvasadoPuntoPaletizado].TipoEnvasadoElementoProduccion = objTipoEnvasado;
          this.tiposEnvasadoPuntosDePaletizado[tempIndexTipoEnvasadoPuntoPaletizado].PaleEnRetrabajo = objPaleEnRetrabajo;
          this.tiposEnvasadoPuntosDePaletizado[tempIndexTipoEnvasadoPuntoPaletizado].CapacidadProductoPorEnvase = capacidadProductoPorEnvase;
          // return;
        } else {
          this.tiposEnvasadoPuntosDePaletizado.push({
            PuntoPaletizado: objPuntoPaletizado,
            TipoEnvasadoElementoProduccion: objTipoEnvasado,
            PaleEnRetrabajo: objPaleEnRetrabajo,
            CapacidadProductoPorEnvase: capacidadProductoPorEnvase,
          });
        }
      }
      // Forzamos que se almacene porque las actualizaciones de atributos de objetos no son detectadas por el watch de vue.
      this.coleccionTiposDeEnvasadosEstablecidosEnLosPuntosDePaletizado = this.tiposEnvasadoPuntosDePaletizado;
    },

    ObtenerTipoEnvasadoPuntoDePaletizado(puntoPaletizado) {
      Log(this, this.ObtenerTipoEnvasadoPuntoDePaletizado.name);
      if (puntoPaletizado == null) {
        LogError(this, this.ObtenerTipoEnvasadoPuntoDePaletizado.name, 'No hay un punto de paletizado');
      }
      if (this.tiposEnvasadoPuntosDePaletizado == null) {
        return null;
      }
      const tempTipoEnvasadoPuntoPaletizado = this.tiposEnvasadoPuntosDePaletizado.find((t) => t.PuntoPaletizado.Id === puntoPaletizado.Id);
      if (tempTipoEnvasadoPuntoPaletizado !== undefined) {
        return tempTipoEnvasadoPuntoPaletizado.TipoEnvasadoElementoProduccion;
      }
      return null;
    },

    ObtenerPedidoAsignadoPuntoDePaletizado(puntoPaletizado) {
      Log(this, this.ObtenerPedidoAsignadoPuntoDePaletizado.name);
      if (this.pedidosAsignadosPuntosDePaletizado == null) {
        return null;
      }
      const tempPedidoAsignadoPuntoPaletizado = this.pedidosAsignadosPuntosDePaletizado.find((t) => t.PuntoPaletizado.Id === puntoPaletizado.Id);
      if (tempPedidoAsignadoPuntoPaletizado !== undefined) {
        return tempPedidoAsignadoPuntoPaletizado.Pedido;
      }
      return null;
    },

    ObtenerExistenciasIncluidasEnPale(puntoPaletizado) {
      Log(this, this.ObtenerExistenciasIncluidasEnPale.name);
      if (this.envasadosLineaProduccion == null) {
        return null;
      }
      const tempEnvadadosPuntoPaletizado = this.envasadosLineaProduccion.filter((t) => t.PuntoDePaletizado.Id === puntoPaletizado.Id);
      if (tempEnvadadosPuntoPaletizado !== undefined) {
        return tempEnvadadosPuntoPaletizado;
      }
      return null;
    },
    ObtenerCapacidadEnvasePuntoDePaletizado(puntoPaletizado) {
      Log(this, this.ObtenerCapacidadEnvasePuntoDePaletizado.name);
      if (puntoPaletizado == null) {
        const errorMsg = 'Se esta llamando al metodo frmPaletizadoMultiPunto->ObtenerCapacidadEnvasePuntoDePaletizado sin un puntoPaletizado seleccionado';
        LogError(this, this.ObtenerCapacidadEnvasePuntoDePaletizado.name, errorMsg);
        return 1; // Por defecto.
      }
      if (this.tiposEnvasadoPuntosDePaletizado == null) {
        return 1;
      } // Por Defecto.
      const tempTipoEnvasadoPuntoPaletizado = this.tiposEnvasadoPuntosDePaletizado.find((t) => t.PuntoPaletizado.Id === puntoPaletizado.Id);
      if (tempTipoEnvasadoPuntoPaletizado !== undefined) {
        return tempTipoEnvasadoPuntoPaletizado.CapacidadProductoPorEnvase;
      }
      return 1; // Por Defecto.
    },

    PedidoEstablecidoParaPuntoDePaletizado() {
      Log(this, this.PedidoEstablecidoParaPuntoDePaletizado.name);
      const tempPedidoEstablecidoEnPunto = { ...this.pedidoPlanificadoSeleccionado };
      // Comprobamos si ya existe un pedido asignado en el punto (Actualizamos, Creamos o Eliminamos si es null)
      if (this.pedidosAsignadosPuntosDePaletizado == null) {
        if (tempPedidoEstablecidoEnPunto != null) {
          this.pedidosAsignadosPuntosDePaletizado = [];
          this.pedidosAsignadosPuntosDePaletizado.push({
            PuntoPaletizado: this.puntoDePaletizadoSeleccionado,
            Pedido: tempPedidoEstablecidoEnPunto,
          });
        }
        return;
      }
      const tempIndexPedidoAsignadoPuntoPaletizado = this.pedidosAsignadosPuntosDePaletizado.findIndex((t) => t.PuntoPaletizado.Id === this.puntoDePaletizadoSeleccionado.Id);
      if (tempIndexPedidoAsignadoPuntoPaletizado !== -1) {
        if (tempPedidoEstablecidoEnPunto != null) {
          this.pedidosAsignadosPuntosDePaletizado[tempIndexPedidoAsignadoPuntoPaletizado].Pedido = tempPedidoEstablecidoEnPunto;
        } else {
          // El pedido asigando se ha eliminado
          this.pedidosAsignadosPuntosDePaletizado.splice(tempIndexPedidoAsignadoPuntoPaletizado, 1);
          if (this.restaurarTipoEnvasadoPaletizadoMultiple) {
            this.tipoEnvasadoPuntoPaletizadoSeleccionado = null;
            this.tipoEnvasadoElementoProduccionSeleccionado = this.tipoEnvasadoPuntoPaletizadoSeleccionado;
            this.tiposEnvasadoPuntosDePaletizado.splice(this.tiposEnvasadoPuntosDePaletizado.findIndex((t) => t.PuntoPaletizado.Id === this.puntoDePaletizadoSeleccionado.Id), 1);
            this.coleccionTiposDeEnvasadosEstablecidosEnLosPuntosDePaletizado = this.tiposEnvasadoPuntosDePaletizado;
            this.ActualizarListadoPuntosDePaletizado();
          }
        }
      } else if (tempPedidoEstablecidoEnPunto != null) {
        this.pedidosAsignadosPuntosDePaletizado.push({
          PuntoPaletizado: this.puntoDePaletizadoSeleccionado,
          Pedido: tempPedidoEstablecidoEnPunto,
        });
      }
    },

    IncluirPaleEnPalesActivosEnPuntosDePaletizado(puntoPaletizado, objAns) {
      Log(this, this.IncluirPaleEnPalesActivosEnPuntosDePaletizado.name);
      this.palesActivosEnPuntosDePaletizado ??= [];
      this.palesActivosEnPuntosDePaletizado.push({
        Id: 0,
        PuntoPaletizado: puntoPaletizado,
        UnidadLogistica: objAns,
      });
      this.ActualizarListadoPuntosDePaletizado();
    },

    ExistePaleActivo(puntoPaletizado) {
      Log(this, this.ExistePaleActivo.name);
      if (this.palesActivosEnPuntosDePaletizado == null) {
        return null;
      }
      const tempPaleActivoEnPuntoDePaletizado = this.palesActivosEnPuntosDePaletizado.find((t) => t.PuntoPaletizado.Id === puntoPaletizado.Id);
      if (tempPaleActivoEnPuntoDePaletizado !== undefined) {
        return tempPaleActivoEnPuntoDePaletizado.UnidadLogistica;
      }
      return null;
    },

    FinalizarPaleEnPuntoDePaletizado(puntoPaletizado, verificarReservaDePalesPedido) {
      Log(this, this.FinalizarPaleEnPuntoDePaletizado.name);
      this.puntoDePaletizadoSeleccionado = puntoPaletizado;
      const tempTipoEnvasado = this.ObtenerTipoEnvasadoPuntoDePaletizado(puntoPaletizado);
      if (tempTipoEnvasado == null) {
        HiNotification.Toast(this.$t('EsNecesarioEstablecerElTipoEnvasado'));
        this.MostrarPopupEdicionProductoPaletizar();
        return;
      }
      const tempExistencias = this.ObtenerExistenciasIncluidasEnPale(puntoPaletizado);
      if (tempExistencias == null) {
        HiNotification.Toast(this.$t('ElPaleNoContieneExistencias'));
        return;
      }
      // FINALIZACION COMUN --> de palé sin retrabajo.
      const objANSRetrabajado = this.ObtenerPaleRetrabajadoEnPuntoPaletizado(puntoPaletizado.Id);
      if (objANSRetrabajado == null) {
        this.FinalizarPaleComunEnPuntoPaletizado(puntoPaletizado, tempTipoEnvasado, tempExistencias, verificarReservaDePalesPedido);
        // FINALIZACION DE PALÉ RETABAJO
      } else {
        const cantidadEnvasesSeleccionados = tempExistencias.reduce((sum, item) => sum + item.CantidadEnvases, 0);
        const cantidadKilosSeleccionados = tempExistencias.reduce((sum, item) => sum + item.CantidadKilos, 0);
        const cantidadKilosEsperadosEnModoPorEnvase = cantidadEnvasesSeleccionados * this.capacidadProductoPorEnvaseElementoSeleccionado;
        const modoRetrabajoPorKilos = cantidadKilosSeleccionados !== cantidadKilosEsperadosEnModoPorEnvase;

        this.FinalizarPaleRetrabajadoEnPuntoDePaletizado(puntoPaletizado, objANSRetrabajado, tempTipoEnvasado, tempExistencias, modoRetrabajoPorKilos);
      }
    },

    FinalizarPaleComunEnPuntoPaletizado(puntoPaletizado, tipoEnvasado, existencias, verificarReservaDePalesPedido) {
      Log(this, this.FinalizarPaleComunEnPuntoPaletizado.name);
      const self = this;
      // Comprobamos si esta asociado con un pedido. Si no existe pedido, se envian los ids a 0.
      let tempIdPedidoVenta = 0;
      let tempIdLineaPedido = 0;
      const tempPedidoAsignado = this.ObtenerPedidoAsignadoPuntoDePaletizado(puntoPaletizado);
      if (tempPedidoAsignado != null) {
        tempIdPedidoVenta = tempPedidoAsignado.IdPedidoVenta;
        tempIdLineaPedido = tempPedidoAsignado.IdLineaPedidoVenta;
        // Si estamos generando un palé asociado a un pedido, comprobamos si es necesario verificar las reservas.
        this.verificarReservaDePalesAntesDeGeneraNuevoPaleDePedido = verificarReservaDePalesPedido;
      } else {
        this.verificarReservaDePalesAntesDeGeneraNuevoPaleDePedido = false;
      } // Los pales sin pedido no se verifican las reservas.
      if (!this.ValidacionesPreviasFinalizacionComunPale(puntoPaletizado, existencias)) {
        return;
      }

      PreloaderGH(true, false, `${this.$t('GenerandoNuevoPale')}...`);
      this.FinalizarPaleConInformacionDeExistencias(puntoPaletizado, tipoEnvasado.Pale, existencias, tempIdPedidoVenta, tempIdLineaPedido).then((objAns) => {
        self.$refs.componentePCUltimosPalesGenerados.ActualizarDatos();
        self.$refs.componentePCPartidasActivasYRecientesLineaParaPaletizado.ActualizarDatos();
        PreloaderGH(false);
        const tempMensajeResultado = `${this.$t('PaleFinalizadoCorrectamente')} ${objAns.NumeroSerie}`;
        HiNotification.Toast(tempMensajeResultado);
        self.PaleFinalizadoEnPuntoDePaletizado(puntoPaletizado);
      }).catch((result) => {
        PreloaderGH(false);
        // El palé no se genero verificamos que el tipo de error por si es necesaria alguna confirmación
        // por parte del usuario antes de iniciar el palé.
        if (result.Codigo === 301) {
          self.valorMensajeDeConfirmacion = result.Mensaje;
          self.actionConfirmarPedidoConPalesReservados = true;
        } else {
          // Cualquier otro mensaje de error lo mostramos.
          HiNotification.Toast(`${this.$t('NoEsPosibleFinalizarElPale')} ${result.Mensaje}`);
        }
      }).finally(() => {
        // Desactivamos el verificado de reservas de la lineaPedido.
        // Por si otro proceso lo utiliza.
        self.verificarReservaDePalesAntesDeGeneraNuevoPaleDePedido = false;
      });
    },

    FinalizarPaleRetrabajadoEnPuntoDePaletizado(puntoPaletizado, objANSRetrabajado, tipoEnvasado, existencias, modoRetrabajoPorKilos) {
      Log(this, this.FinalizarPaleRetrabajadoEnPuntoDePaletizado.name);
      const self = this;
      PreloaderGH(true, false, 'Finalizando palé retrabajado...');
      this.FinalizarPaleRetrabajoConInformacionDeExistencias(puntoPaletizado, objANSRetrabajado.Id, existencias, modoRetrabajoPorKilos).then((objAns) => {
        self.$refs.componentePCUltimosPalesGenerados.ActualizarDatos();
        self.$refs.componentePCPartidasActivasYRecientesLineaParaPaletizado.ActualizarDatos();
        PreloaderGH(false);
        const tempMensajeResultado = `${this.$t('PaleRetrabajoFinalizadoCorrectamente')} ${objAns.NumeroSerie}`;
        HiNotification.Toast(tempMensajeResultado);
        self.EliminarPaleParaRetrabajoAsignadoEnPuntoDePaletizadoSeleccionado();
      }).catch((result) => {
        PreloaderGH(false);
        HiNotification.Toast(`${this.$t('NoEspobleFinalizarPaleRetrabajo')} ${result.Mensaje}`);
      });
    },

    ValidacionesPreviasFinalizacionComunPale(puntoPaletizado, existencias) {
      Log(this, this.ValidacionesPreviasFinalizacionComunPale.name);
      // Comprobamos si se trata de un palé mixto si esta permitido en el punto de paletizado.
      let tempIdsFamiliasDelPale = [];
      if (puntoPaletizado.AdmiteMixtos === false) {
        existencias.forEach((e) => {
          tempIdsFamiliasDelPale.push(e.TipoEnvasado.Articulo.Familia.Id);
        });
        tempIdsFamiliasDelPale = tempIdsFamiliasDelPale.filter((valor, indiceActual, arr) => arr.indexOf(valor) === indiceActual); // Eliminamos duplicados
        if (tempIdsFamiliasDelPale.length > 1) {
          HiNotification.Toast(this.$t('NoEsPosibleFinalizarPaleMixto'));
          return false;
        }
      }
      return true;
    },

    PaleFinalizadoEnPuntoDePaletizado(puntoPaletizado) {
      Log(this, this.PaleFinalizadoEnPuntoDePaletizado.name);
      // Eliminamos las existencias del palé
      const tempExistenciasPP = this.ObtenerExistenciasIncluidasEnPale(puntoPaletizado);
      const self = this;
      tempExistenciasPP.forEach((existencia) => {
        const tempIndexExistencia = self.envasadosLineaProduccion.findIndex((e) => (e.Partida.Id === existencia.Partida.Id && e.PuntoDePaletizado.Id === existencia.PuntoDePaletizado.Id));
        self.envasadosLineaProduccion.splice(tempIndexExistencia, 1);
      });

      // Comprobamos si el punto de paletizado esta asociado con un pedido para restar el número de palés restantes de confeccionar.
      const tempPedidoPlanificadoEnPunto = this.ObtenerPedidoAsignadoPuntoDePaletizado(puntoPaletizado);
      if (tempPedidoPlanificadoEnPunto != null) {
        if (tempPedidoPlanificadoEnPunto.CantidadPalet > 1) {
          const tempNuevaCantidad = tempPedidoPlanificadoEnPunto.CantidadPalet - 1;
          this.pedidosAsignadosPuntosDePaletizado.find((t) => t.PuntoPaletizado.Id === puntoPaletizado.Id).CantidadPalet = tempNuevaCantidad;
          this.pedidosAsignadosPuntosDePaletizado.find((t) => t.PuntoPaletizado.Id === puntoPaletizado.Id).Pedido.CantidadPalet = tempNuevaCantidad;
        } else {
          this.EliminarPedidoPlanificadoEnPuntoDePaletizado(puntoPaletizado.Id);
        }
      }

      this.ActualizarListadoPuntosDePaletizado();
    },

    EliminarPedidoPlanificadoEnPuntoDePaletizado(idPuntoPaletizado) {
      Log(this, this.EliminarPedidoPlanificadoEnPuntoDePaletizado.name);
      const tempIndexPedido = this.pedidosAsignadosPuntosDePaletizado.findIndex((t) => t.PuntoPaletizado.Id === idPuntoPaletizado);
      this.pedidosAsignadosPuntosDePaletizado.splice(tempIndexPedido, 1);
    },

    async ConfirmarEliminarRegistroEnvasadoEnPale(registroEnvasado, confirmacionEliminacion) {
      Log(this, this.ConfirmarEliminarRegistroEnvasadoEnPale.name);
      this.registroEnvasadoPaleSeleccionado = registroEnvasado;
      if (confirmacionEliminacion === false) {
        return;
      }

      if (confirmacionEliminacion === true) {
        this.EliminarRegistroDeEnvasadoEnPale();
      }

      if (confirmacionEliminacion === undefined) {
        const res = await ConfirmDialogGH(this.$t('ConfirmarEliminacionMercancia'), this.$t('EliminarConfeccion'));

        if (res) {
          this.EliminarRegistroDeEnvasadoEnPale();
        }
      }
    },

    EliminarRegistroDeEnvasadoEnPale() {
      Log(this, this.EliminarRegistroDeEnvasadoEnPale.name);
      const tempIndexExistencia = this.envasadosLineaProduccionCLONParaEdicion.findIndex((e) => (e.Partida.Id === this.registroEnvasadoPaleSeleccionado.Partida.Id && this.registroEnvasadoPaleSeleccionado.PuntoDePaletizado.Id === e.PuntoDePaletizado.Id));
      this.envasadosLineaProduccionCLONParaEdicion.splice(tempIndexExistencia, 1);
    },

    CancelarEdicion() {
      Log(this, this.CancelarEdicion.name);
      this.popupDetalleCantidadEnvasesYKilosPorPartida = false;
    },

    ConfirmarEdicion() {
      Log(this, this.ConfirmarEdicion.name);
      this.popupDetalleCantidadEnvasesYKilosPorPartida = false;
      this.envasadosLineaProduccion = Object.assign([], this.envasadosLineaProduccionCLONParaEdicion); //  Clonamos  el array []
      sleep(10).then(() => {
        this.modoEdicionActivo = false;
      });
    },

    ActualizarPartidasYPalesGenerados() {
      Log(this, this.ActualizarPartidasYPalesGenerados.name);
      this.$refs.componentePCUltimosPalesGenerados.ActualizarDatos();
      this.$refs.componentePCPartidasActivasYRecientesLineaParaPaletizado.RestablecerValores();
      this.$refs.componentePCPartidasActivasYRecientesLineaParaPaletizado.ActualizarDatos(true);
    },

    AbrirFormularioDeModelosParaPuntosDePaletizado() {
      Log(this, this.AbrirFormularioDeModelosParaPuntosDePaletizado.name);
      this.popupMostrarPopupModelosParaPuntosDePaletizado = true;
    },

    PlantillasTipoEnvasadoActualizadas(plantillasTipoEnvasado) {
      Log(this, this.PlantillasTipoEnvasadoActualizadas.name);
      const self = this;
      plantillasTipoEnvasado.forEach((plantilla) => {
        const tempPosiblePaleRetrabajadoEnPuntoPaletizado = self.ObtenerPaleRetrabajadoEnPuntoPaletizado(plantilla.PuntoPaletizado.Id);
        self.AsignarTipoEnvasadoPuntoPaletizado(plantilla.PuntoPaletizado, plantilla.TipoEnvasado, tempPosiblePaleRetrabajadoEnPuntoPaletizado);
      });
      // Forzamos que se almacene porque las actualizaciones de atributos de objetos no son detectadas por el watch de vue.
      this.coleccionTiposDeEnvasadosEstablecidosEnLosPuntosDePaletizado = this.tiposEnvasadoPuntosDePaletizado;
    },

    AbrirPopupParaBusquedaDePales() {
      Log(this, this.AbrirPopupParaBusquedaDePales.name);
      if (this.lineaSeleccionada == null || this.lineaSeleccionada === undefined || this.puntoDePaletizadoSeleccionado == null || this.puntoDePaletizadoSeleccionado === undefined) {
        HiNotification.Toast(this.$t('NecesarioEstablecerLineaYPunto'));
        return;
      }
      this.nombreFrmPCUltimosPalesGenerados = 'Busqueda de Palé';
      this.$refs.componentePCUltimosPalesGenerados.VerMasPales();
    },

    async ReabrirPaleConfeccionadoEnPuntoDePaletizado(paleParaReabrir) {
      Log(this, this.ReabrirPaleConfeccionadoEnPuntoDePaletizado.name);
      // Confirmamos que no exista mercancia ya incluida en el punto de paletizado.
      const tempExistenciasPP = this.ObtenerExistenciasIncluidasEnPale(this.puntoDePaletizadoSeleccionado);
      if (tempExistenciasPP !== undefined && tempExistenciasPP !== null && tempExistenciasPP.length > 0) {
        HiNotification.Toast(this.$t('PaleNoReabiertoExisteUnPaleEncurso'));
        return;
      }
      // Confirmamos que no exista ya un pale reabierto en el PP.
      if (this.ObtenerPaleRetrabajadoEnPuntoPaletizado(this.puntoDePaletizadoSeleccionado.Id) != null) {
        HiNotification.Toast(this.$t('PaleNoReabiertoExisteUnPaleEncursoRetrabajo'));
        return;
      }
      // Obtenemos el desglose de las existencias del palé
      PreloaderGH(true, false, this.$t('ObteniendoDetallePartidasDelPale'));
      const res = await this.ObtenerExistenciasDeUnPaleParaRetrabajo(paleParaReabrir.Id);
      PreloaderGH(false);
      this.ProcesarExistenciasDeUnPaleParaRetrabajo(paleParaReabrir, res.Existencias);
    },

    async ProcesarExistenciasDeUnPaleParaRetrabajo(paleReabrir, existencias) {
      Log(this, this.ProcesarExistenciasDeUnPaleParaRetrabajo.name);
      // Establecemos el tipo envasado en función de las existencias que tiene el palé
      // NOTA: Si es un palé mixto el sistema obtendra el tipo de envasado de la primera existencia de tipo producto y de tipo envase
      const tempObjTipoEnvasadoPaleRetrabajado = this.ObtenerTipoDeEnvasadoDeUnPaleParaRetrabajo(existencias);
      await this.AsignarTipoEnvasadoPuntoPaletizado(this.puntoDePaletizadoSeleccionado, tempObjTipoEnvasadoPaleRetrabajado, paleReabrir);
      existencias.forEach((e) => {
        if (e.Articulo.TipoArticulo === 'Producto') {
          const existenciasDeTipoEnvaseDelProducto = this.ObtenerExistenciaDeTipoEnvaseDelProducto(e, existencias);
          // Formateamos la existencia para incluirla con el formato correcto
          if (existenciasDeTipoEnvaseDelProducto === null) {
            HiNotification.Toast('No es posible retrabajar el palé, las existencias no contienen un envase válido para el producto');
            return;
          }
          const tempTipoConfeccion = {
            Articulo: e.Articulo,
            Envase: existenciasDeTipoEnvaseDelProducto.Articulo,
          };
          const partida = e.PartidaOrigen != null ? e.PartidaOrigen : e.Partida;
          this.IncluirRegistroEnvadadoEnPuntoDePaletizado(tempTipoConfeccion, Math.ceil(existenciasDeTipoEnvaseDelProducto.Cantidad), e.Cantidad, partida, true);
        }
      });
      this.tipoEnvasadoPuntoPaletizadoSeleccionado = this.ObtenerTipoEnvasadoPuntoDePaletizado(this.puntoDePaletizadoSeleccionado);
    },

    async ObtenerCantidadDeKilosPorEnvaseDeUnProducto(articuloTipoEnvase, articuloTipoProducto) {
      PreloaderGH(true, false, `${this.$t('ObtenerCapacidadPorEnvase')}...`);
      const pedidoAsignadoPuntoPaletizado = this.ObtenerPedidoAsignadoPuntoDePaletizado(this.puntoDePaletizadoSeleccionado);
      let capacidad = 1;
      capacidad = await this.ObtenerCapacidadEnvaseYProducto(articuloTipoProducto.Id, articuloTipoEnvase.Id, pedidoAsignadoPuntoPaletizado ? pedidoAsignadoPuntoPaletizado.IdLineaPedidoVenta : 0);
      PreloaderGH(false);
      return capacidad;
    },

    ObtenerTipoDeEnvasadoDeUnPaleParaRetrabajo(existencias) {
      Log(this, this.ObtenerTipoDeEnvasadoDeUnPaleParaRetrabajo.name);
      const existenciaDeTipoProducto = existencias.filter((e) => (e.Articulo.TipoArticulo === 'Producto'))[0];
      const existenciaDeTipoEnvase = existencias.filter((e) => (e.Articulo.TipoArticulo === 'Envase') && (e.Partida.Id === existenciaDeTipoProducto.Partida.Id))[0];
      const existenciaDeTipoPale = existencias.filter((e) => (e.Articulo.TipoArticulo === 'Palet'))[0];
      // Retornamos con la estructura de TipoEnvasado
      const tempTipoEnvadado = {
        Articulo: (existenciaDeTipoProducto != null ? existenciaDeTipoProducto.Articulo : null),
        Envase: (existenciaDeTipoEnvase != null ? existenciaDeTipoEnvase.Articulo : null),
        Pale: (existenciaDeTipoPale != null ? existenciaDeTipoPale.Articulo : null),

      };
      return tempTipoEnvadado;
    },

    ObtenerExistenciaDeTipoEnvaseDelProducto(existenciaProducto, existencias) {
      Log(this, this.ObtenerExistenciaDeTipoEnvaseDelProducto.name);
      const existenciasDeTipoEnvaseDelProducto = existencias.filter((e) => (e.Articulo.TipoArticulo === 'Envase') && (e.Partida.Id === existenciaProducto.Partida.Id))[0];
      if (existenciasDeTipoEnvaseDelProducto === undefined) {
        return 0;
      } // Hay un error y no hay existencia de tipo envase en el palé para el producto
      return existenciasDeTipoEnvaseDelProducto;
    },

    EliminarPaleParaRetrabajoAsignadoEnPuntoDePaletizadoSeleccionado() {
      Log(this, this.EliminarPaleParaRetrabajoAsignadoEnPuntoDePaletizadoSeleccionado.name);
      // Eliminamos el palé en retrabajo asignado al PP.
      this.tiposEnvasadoPuntosDePaletizado.find((t) => t.PuntoPaletizado.Id === this.puntoDePaletizadoSeleccionado.Id).PaleEnRetrabajo = null;

      // Eliminamos las existencias del Pale
      const tempExistenciasPP = this.ObtenerExistenciasIncluidasEnPale(this.puntoDePaletizadoSeleccionado);
      const self = this;
      tempExistenciasPP.forEach((existencia) => {
        const tempIndexExistencia = self.envasadosLineaProduccion.findIndex((e) => (e.Partida.Id === existencia.Partida.Id && e.PuntoDePaletizado.Id === self.puntoDePaletizadoSeleccionado.Id));
        self.envasadosLineaProduccion.splice(tempIndexExistencia, 1);
      });
      if (this.restaurarTipoEnvasadoPaletizadoMultiple) {
        this.tipoEnvasadoPuntoPaletizadoSeleccionado = null;
        this.tipoEnvasadoElementoProduccionSeleccionado = this.tipoEnvasadoPuntoPaletizadoSeleccionado;
        this.tiposEnvasadoPuntosDePaletizado.splice(this.tiposEnvasadoPuntosDePaletizado.findIndex((t) => t.PuntoPaletizado.Id === this.puntoDePaletizadoSeleccionado.Id), 1);
      }
      // Forzamos el Guardado, el watch no detecta el cambio en la propiedad de un objeto.
      this.coleccionTiposDeEnvasadosEstablecidosEnLosPuntosDePaletizado = this.tiposEnvasadoPuntosDePaletizado;
      this.ActualizarListadoPuntosDePaletizado();
    },

    /**
     * Handles the selection of an option in the side navbar.
     * @param {SideNavbarItem} item - The selected option.
     */
    OpcionSideNavbarSeleccionada(item) {
      Log(this, this.OpcionSideNavbarSeleccionada.name);

      if (item.key === 'more') {
        this.popupConfiguracionPaletizadoMultiple = true;
      }
    },

    SolicitudRestablecerFormularioPaletizadoMultiple() {
      Log(this, this.SolicitudRestablecerFormularioPaletizadoMultiple.name);
      const self = this;
      self.actionsToPopover ||= f7.actions.create({
        buttons: [
          {
            text: this.$t('EstaAccionRestableceraElFormulario'),
            label: true,
          },
          {
            text: this.$t('common.confirm').toUpperCase(),
            color: 'teal',
            bold: true,
            onClick: self.RestablecerFormularioPaletizadoMultiple,
          },
          {
            text: this.$t('common.cancel').toUpperCase(),
            color: 'red',
          },
        ],
        targetEl: self.$el.querySelector('.button-to-popover'),
      });

      // Open
      self.actionsToPopover.open();
    },

    RestablecerFormularioPaletizadoMultiple() {
      Log(this, this.RestablecerFormularioPaletizadoMultiple.name);
      this.popupConfiguracionPaletizadoMultiple = false;
      this.envasadosLineaProduccion = null;
      this.tiposEnvasadoPuntosDePaletizado = null;
      this.pedidosAsignadosPuntosDePaletizado = null;
      this.ActualizarListadoPuntosDePaletizado();
      HiNotification.Toast('Se ha restrablecido el formulario.');
    },

    ObtenerPalesActivosEnLineaProduccion() {
      Log(this, this.ObtenerPalesActivosEnLineaProduccion.name);
      const self = this;
      this.contadorDeLlamadasPendientesDeRespuestaEnFrm += 1;
      return new Promise((resolve, reject) => {
        ConexionTA.callObtenerPalesActivosEnLineaProduccion(
          this.lineaSeleccionada.Id,
        ).then((result) => {
          if (result.Valor) {
            resolve(JSON.parse(result.Mensaje));
            HiDialog.Preloader(false);
          } else {
            reject();
            HiNotification.Toast(result.Mensaje);
            HiDialog.Preloader(false);
          }
        })
          .catch((error) => {
            reject(error);
            HiNotification.Alert(this.$t('common.checkYourConnection'), this.$t('common.error'));
          })
          .finally(() => {
            self.contadorDeLlamadasPendientesDeRespuestaEnFrm -= 1;
          });
      });
    },

    FinalizarPaleConInformacionDeExistencias(puntoPaletizado, tipoPale, existencias, idPEdidoVenta, idLineaPedido) {
      Log(this, this.FinalizarPaleConInformacionDeExistencias.name);
      const self = this;
      this.contadorDeLlamadasPendientesDeRespuestaEnFrm += 1;
      return new Promise((resolve, reject) => {
        ConexionTA.callFinalizarPaleConInformacionDeExistencias(
          puntoPaletizado.Id,
          tipoPale.Id,
          idPEdidoVenta, // idPedidoVenta --> Sin pedido = 0
          idLineaPedido, // idLineaPedido --> Sin pedido = 0
          existencias,
          self.verificarReservaDePalesAntesDeGeneraNuevoPaleDePedido,
        ).then((result) => {
          if (result.Valor) {
            resolve(JSON.parse(result.Mensaje));
            HiDialog.Preloader(false);
          } else {
            reject(result);
            HiDialog.Preloader(false);
          }
        })
          .catch((error) => {
            reject(error);
            HiNotification.Alert(this.$t('common.checkYourConnection'), this.$t('common.error'));
          })
          .finally(() => {
            self.contadorDeLlamadasPendientesDeRespuestaEnFrm -= 1;
          });
      });
    },

    FinalizarPaleRetrabajoConInformacionDeExistencias(puntoPaletizado, idPaleReabierto, existencias, modoRetrabajoPorKilos) {
      Log(this, this.FinalizarPaleRetrabajoConInformacionDeExistencias.name);
      const self = this;
      this.contadorDeLlamadasPendientesDeRespuestaEnFrm += 1;
      return new Promise((resolve, reject) => {
        ConexionTA.callFinalizarPaleRetrabajoConInformacionDeExistencias(
          puntoPaletizado.Id,
          idPaleReabierto,
          existencias,
          modoRetrabajoPorKilos,
        ).then((result) => {
          if (result.Valor) {
            resolve(JSON.parse(result.Mensaje));
            HiDialog.Preloader(false);
          } else {
            reject(result);
            HiDialog.Preloader(false);
          }
        })
          .catch((error) => {
            reject(error);
            HiNotification.Alert(this.$t('common.checkYourConnection'), this.$t('common.error'));
          })
          .finally(() => {
            self.contadorDeLlamadasPendientesDeRespuestaEnFrm -= 1;
          });
      });
    },

    ImprimirEtiquetaIncluirPartidaEnPaleDePuntoPaletizado(idPuntoPaletizado, idPartida, idEnvase, cantidadKilos, cantidadEnvases) {
      Log(this, this.ImprimirEtiquetaIncluirPartidaEnPaleDePuntoPaletizado.name);
      const self = this;
      this.contadorDeLlamadasPendientesDeRespuestaEnFrm += 1;
      return new Promise((resolve, reject) => {
        ConexionTA.callImprimirEtiquetaIncluirPartidaEnPaleDePuntoPaletizado(
          idPuntoPaletizado,
          idPartida,
          idEnvase,
          cantidadKilos,
          cantidadEnvases,
        ).then((result) => {
          if (result.Valor) {
            resolve(JSON.parse(result.Mensaje));
          } else {
            reject(result.Mensaje);
            HiNotification.Toast(result.Mensaje);
          }
        })
          .catch((error) => {
            reject(error);
            HiNotification.Alert(this.$t('common.checkYourConnection'), this.$t('common.error'));
          })
          .finally(() => {
            self.contadorDeLlamadasPendientesDeRespuestaEnFrm -= 1;
          });
      });
    },

    async ObtenerExistenciasDeUnPaleParaRetrabajo(idArticuloNumeroSerie) {
      Log(this, this.ObtenerExistenciasDeUnPaleParaRetrabajo.name);
      const self = this;
      this.contadorDeLlamadasPendientesDeRespuestaEnFrm += 1;
      return new Promise((resolve, reject) => {
        ConexionTA.callObtenerExistenciasDeUnPaleParaRetrabajo(idArticuloNumeroSerie).then((result) => {
          if (result.Valor) {
            const auxiliarUnidadLogistica = JSON.parse(result.Mensaje);
            resolve(auxiliarUnidadLogistica);
          } else {
            reject(result.Mensaje);
          }
        })
          .catch((error) => {
            reject(error);
            HiNotification.Alert(this.$t('common.checkYourConnection'), this.$t('common.error'));
          })
          .finally(() => {
            self.contadorDeLlamadasPendientesDeRespuestaEnFrm -= 1;
          });
      });
    },
    async ComprobarSiEsPosibleAñadirMercanciaAlPP(objPunto) {
      this.PuntoPaletizadoSeleccionado(objPunto);
      // this.puntoDePaletizadoSeleccionado = objPunto;
      await sleep(100); // Esperar que se seleccione el PP para continuar con la apertura del tipo de envasado
      this.tipoEnvasadoPuntoPaletizadoSeleccionado = this.ObtenerTipoEnvasadoPuntoDePaletizado(objPunto);

      if (this.tipoEnvasadoPuntoPaletizadoSeleccionado == null) {
        HiNotification.Toast(this.$t('EsNecesarioEstablecerUnTipoDeEnvadado'));
        await sleep(100);
        this.MostrarPopupEdicionProductoPaletizar(objPunto);
        // this.popupMostrarPopupEdicionProductoPaletizar = true;
      }
    },

    UbicacionPalesProducidosPuntoPaletizadoModificada(nuevaUbicacion) {
      Log(this, this.UbicacionPalesProducidosPuntoPaletizadoModificada.name);
      this.puntoDePaletizadoSeleccionado.UbicacionPalesProducidos = nuevaUbicacion;
      this.puntosDePaletizado.filter((pp) => pp.Id === this.puntoDePaletizadoSeleccionado.Id).UbicacionPalesProducidos = nuevaUbicacion;
    },

    async ObtenerCapacidadEnvaseYProducto(idEnvase, idProducto, idLineaPedidoVenta) {
      Log(this, this.ObtenerCapacidadEnvaseYProducto.name);
      const res = await ConexionTA.callObtenerCapacidadEnvaseYProducto(idProducto, idEnvase, idLineaPedidoVenta);
      if (res != null && res.Valor) {
        return SoporteNumeracion.ParsearNumeroDesdeCadena(res.Mensaje);
      }
      return 1;
    },
  },
};
</script>

<style scoped lang="scss">
.div-frmPaletizadoMultiPunto {
  // TODO: Remove when migrated to new styles
  --f7-grid-row-gap: 0;
  //

  --information-bar-padding-bottom: 0;

  background-color: rgb(247 247 247);
  height: 100%;
  overflow-y: hidden;
}

.div-contenido {
  margin-left: 100px;
  margin-right: 10px;
}

.menu {
  background-color: #ebecf0;
  box-shadow: 1px 0 1px 0 rgb(9 30 66 / 25%), 0 0 1px 0 rgb(9 30 66 / 31%);
  width: 80px;
  height: 100vh;
  float: left;
}

.div-contenedorPartidasLinea {
  background-color: #ebecf0;
  border-radius: 4px 4px 10px 10px;
  border: 2px solid #ebecf0;
  min-height: 33vh;
  margin-right: 10px;
  margin-top: 14px;
}

.div-contenedorPartidasLinea .cabecera {
  height: 26px;
  display: flex;
  align-items: center;
  padding-left: 17px;
}

.div-contenedorUltimosPalesGenerados {
  background-color: #ebecf0;
  border-radius: 4px 4px 10px 10px;
  min-height: 33vh;
  margin-right: 10px;
  margin-top: 14px;
}

.div-contenedorUltimosPalesGenerados .cabecera {
  height: 26px;
  display: flex;
  align-items: center;
  padding-left: 17px;
}

.div-elementoTarjeta {
  background-color: #fff;
  margin-top: 15px;
  vertical-align: middle;
  border: 2px solid #fafbfc;
  border-radius: 4px;
  box-shadow: 0 2px 11px 0 rgb(56 62 68 / 9%);
}

.div-elementoTarjeta .row-cabeceraTarjeta {
  min-height: 34px;
  background-color: #fafbfc;
  border-radius: 4px 4px 0 0;
  align-items: center;
}

.div-elementoTarjetaSeleccionado {
  border: 2px solid var(--his-kiwi-pulp);
  border-radius: 4px;
}

.div-elementoNoEditable {
  opacity: 0.5;
}

.span-tituloColumnas {
  color: var(--his-plum-shadow);
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.17px;
  line-height: 14px;
  text-align: left;
}

.div-puntosPaletizadoDisponibles {
  max-height: 100%;
  height: calc((100vh - var(--information-bar-height)) * 0.78);
  margin-top: 14px;
  background-color: #ebecf0;
  border-radius: 4px 4px 10px 10px;
  padding-left: 10px;
  padding-right: 10px;
}

.div-puntosPaletizadoDisponibles-scroll {
  overflow-y: auto;
  max-height: 100%;
  height: 71vh;
  width: 100%;
  margin-top: 10px;
}

.div-cabeceraTarjetaDerecha {
  display: flex;
  justify-content: flex-end;
  align-items: -webkit-right;
}

.div-contenidoComponentePCPartidasActivasYRecintesLinea {
  height: 33vh;
  overflow-y: auto;
}

.row-elementoTarjetaPuntoPaletizado {
  min-height: 85px;
  display: flex;
  align-items: center;
  padding: 12px;
}

.div-opcionesDePuntoPaletizado {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 85px;
}

.btn-opcionesDePuntoPaletizado {
  margin: 3px;
}

.span-verMas {
  color: var(--his-kiwi-pulp);
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.17px;
  line-height: 14px;
  text-align: left;
}

.div-verMas {
  padding-bottom: 6px;
  padding-top: 6px;
}

/***** Copiar en APP ***/

/*** Estilos Popup ****/

.div-separador {
  width: 94%;
  bottom: 45px;
  position: absolute;
}

.div-opcionesActions {
  width: 94%;
  bottom: 10px;
  position: absolute;
}

.div-elementosFrm {
  margin-left: 10px;
  margin-right: 25px;
  margin-bottom: 5px;
  margin-top: 10px;
  max-height: 100%;
  height: 65vh;
  overflow-y: auto;
}

.col-tituloPuntoYTipoEnvasado {
  min-height: 70px;
}

.div-existenciaDelPale {
  margin-left: 28px;
  padding-right: 28px;
  margin-top: 14px;
  margin-bottom: 14px;
  border-bottom: 0 solid var(--his-disabled);
}

.btn-actualizarPartidasYPalesGenerados {
  float: right;
  margin-right: 16px;
}

.span-cargarModelo {
  color: #fff;
  font-size: 11px;
  font-weight: 400;
  line-height: 13px;
  text-align: center;
}

.div-cargarModelo {
  background-color: var(--his-plum-shadow);
  float: right;
  border-radius: 4px;
  box-shadow: 0 4px 4px 0 rgb(122 134 154 / 15%);
  width: 100px;
  height: 23px;
  text-align: center;
  margin-top: 7px;
}

.div-buscarPale {
  background-color: var(--his-plum-shadow);
  float: right;
  border-radius: 4px;
  box-shadow: 0 4px 4px 0 rgb(122 134 154 / 15%);
  width: 100px;
  height: 23px;
  text-align: center;
  margin-top: 7px;
  margin-right: 10px;
}

.div-elementosPuntosDePaletizado {
  margin-top: 14px;
}

.div-contenidoComponentePCUltimosPalesGenerados {
  height: 30vh;
  overflow-y: auto;
}

.div-rectanguloReabierto {
  background-color: #ff3b30;
  border-radius: 3px;
  width: 150px;
  height: 19px;
  margin-left: 10px;
  margin-right: 10px;
  text-align: center;
  margin-top: 6px;
}

.div-rectanguloReabierto span {
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  line-height: 14px;
}

.div-rectanguloUbicacionDestinoModificada {
  float: right;
  background-color: #d9918d;
  border-radius: 3px;
  width: 96px;
  height: 19px;
  margin-left: 10px;
  margin-right: 10px;
  text-align: center;
  margin-top: 6px;
}

.div-rectanguloUbicacionDestinoModificada span {
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  line-height: 14px;
}

.col-cabeceraDerecha {
  float: right;
  margin-bottom: 8px;
}

.div-logoHispatecDerecha {
  max-width: 250px;
  margin-top: 18px;
  border-left: 1px solid rgb(151 151 151 / 30%);
  text-align: end;
  padding-right: 15px;

  /* height: 79px; */
}

/*****  Popup Configuracion Formulario *****/

.div-btnRestablecerFrm {
  background-color: rgb(172 160 149 / 20%);
  border: 1px solid var(--his-kiwi-pulp);
  border-radius: 8px;
  width: 184px;
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.div-btnRestablecerFrm span {
  color: var(--his-kiwi-pulp);
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0.26px;
  line-height: 22px;
  text-align: center;
}

.col-opcionesDerecha {
  text-align: -webkit-right;
  padding-right: 31px;
}

.div-configuracionMultiPunto-cabeceraFormulario {
  margin-left: 22px;
  margin-top: 10px;
}

.span-cantidadesDetalle {
  color: var(--his-oliva);
  font-size: 30px;
  font-weight: 400;
  line-height: 18px;
  text-align: center;
}

.span-ttlcantidadesDetalle {
  color: var(--his-oliva);
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  text-align: center;
}

.textoCentrado {
  text-align: center;
}

.col-cantidadesDetalle {
  padding-top: 27px;
}

.oval-informacionDeAlerta {
  float: right;
  margin-right: 14px;
  margin-top: 7px;
}

.oval-informacionDeAlerta-tarjetaPedido {
  margin-top: 9px;
  margin-right: 5px;
}

.div-mensajeInformacionDeLaConfeccion {
  background: #f2c0c0;
  padding: 10px;
}

.div-botonesCabeceraFijos {
  box-sizing: border-box;
  margin-bottom: 12px;
  height: 30px;
  padding-top: 10px;
}

.img-logoHispatec {
  padding-left: 45px;
}

.temp-padding-top {
  padding-top: 20px;
}
</style>
